import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import About from "../../components/Tournament/About";
import Header from "../../components/Tournament/Header";
import Sidebar from "../../components/Tournament/Sidebar";
import Notfound from "../Notfound";
import spinnerIcon from "../../assets/icons/spinner.svg";
import { getTournament } from "../../helpers/apis/guest";
import LiveTournament from "../../components/Tournament/LiveTournament/LiveTournament";
import TournamentMain from "../../components/Tournament/Main";

function PublicTournament() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [dataFound, setDataFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const auth = useSelector((state) => state.auth);

  const fetchTournament = () => {
    getTournament(id, auth)
      .then((res) => {
        if (res.data.success) {
          setDataFound(true);
          setData(res.data.data);
        }
      })
      .catch(() => {
        setDataFound(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    setDataFound(false);
    fetchTournament();
  }, []);

  if (loading && !dataFound)
    return (
      <div className="flex justify-center items-center h-[80vh]">
        <img src={spinnerIcon} className="w-9 animate-spin" alt="Loading..." />
      </div>
    );

  if (!loading && !dataFound) return <Notfound />;

  // if (dataFound && ["scheduled"].includes(data?.registration?.status))
  //   return <LiveTournament data={data} />;

  return (
    <div className="max-w-[1400px] bg-[#F8F9FA] px-5 py-10 sm:px-10 mx-auto">
      <TournamentMain/>
    </div>
  );
}

export default PublicTournament;
